import React from 'react';

import colors from '@constants/colors';

import { IIconProps, TIconType } from '../interface';

const UsersIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
			{...props?.innerSvgProps}
		>
			<g clipPath='url(#clip0_9694_33270)'>
				<path
					d='M9.25 15C11.9424 15 14.125 12.8174 14.125 10.125C14.125 7.43261 11.9424 5.25 9.25 5.25C6.55761 5.25 4.375 7.43261 4.375 10.125C4.375 12.8174 6.55761 15 9.25 15Z'
					fill={props?.isActive ? colors.indigo70 : 'none'}
					stroke='#2E2E6B'
					strokeMiterlimit='10'
				/>
				<path
					d='M15.5687 5.42813C15.9997 5.31124 16.4441 5.25136 16.8906 5.25C18.1836 5.25 19.4235 5.76361 20.3378 6.67785C21.252 7.59209 21.7656 8.83207 21.7656 10.125C21.7656 11.4179 21.252 12.6579 20.3378 13.5721C19.4235 14.4864 18.1836 15 16.8906 15'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M2.5 18.5063C3.2612 17.4231 4.27191 16.539 5.44676 15.9286C6.6216 15.3183 7.92608 14.9997 9.25 14.9997C10.5739 14.9997 11.8784 15.3183 13.0532 15.9286C14.2281 16.539 15.2388 17.4231 16 18.5063'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
				<path
					d='M16.8906 15C18.2147 14.9992 19.5194 15.3174 20.6944 15.9277C21.8693 16.5381 22.8799 17.4225 23.6406 18.5063'
					stroke='#2E2E6B'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
			</g>
			<defs>
				<clipPath id='clip0_9694_33270'>
					<rect
						fill='white'
						height='24'
						width='24'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default UsersIcon;
